function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.8261 0H4.17391C3.06726 0.00115522 2.00625 0.461265 1.22373 1.27936C0.44121 2.09745 0.00110499 3.20668 0 4.36364V24.7273C0 24.9202 0.0732917 25.1051 0.203752 25.2415C0.334212 25.3779 0.511154 25.4545 0.695652 25.4545H24.3478C24.5323 25.4545 24.7093 25.3779 24.8397 25.2415C24.9702 25.1051 25.0435 24.9202 25.0435 24.7273V4.36364C25.0435 1.94473 27.4783 1.50909 27.8497 1.45455C28.5836 1.46107 29.2853 1.77044 29.8021 2.31529C30.3188 2.86015 30.6087 3.59636 30.6087 4.36364V30.5455H5.56522V26.9091H4.17391V31.2727C4.17391 31.4656 4.2472 31.6506 4.37767 31.787C4.50813 31.9234 4.68507 32 4.86957 32H31.3043C31.4888 32 31.6658 31.9234 31.7962 31.787C31.9267 31.6506 32 31.4656 32 31.2727V4.36364C31.9989 3.20668 31.5588 2.09745 30.7763 1.27936C29.9937 0.461265 28.9327 0.00115522 27.8261 0Z",
  fill: "current"
});

function SvgOrderFabrics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderFabrics);
export default __webpack_public_path__ + "static/media/OrderFabrics.6c5340c9.svg";
export { ForwardRef as ReactComponent };